export default __webpack_public_path__ + "static/media/PowerSlugYellow.256.30be0659.png";